export const ROUTE_ACCOUNT_SETTINGS = '/dashboard/settings/account';
export const ROUTE_TRANSACTIONS = '/dashboard/banking/transactions';
